export default __webpack_public_path__ + "static/media/arima.0bdd88a4.woff2";